<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
                        <li class="pr-3"><a class="cursor-pointer">Account</a></li>
                        <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
                        <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Terms of Use</a></li>
                    </ul>

                    <h3>Terms of Use</h3>

                    <p>
                        By using this application and our websites, you signify your acceptance of this Terms of Use.
                        If you do not agree, please exit this application and/or websites.
                        <br><br>
                        Your continued use of the application and/or websites following the posting of changes to this
                        Policy
                        will mean that you accept and hereby agree to the terms and conditions detailed below.
                        <br><br>
                        A copy of this agreement can be provided to you upon request.
                    </p>
                    <Accordion>
                        <AccordionTab header="1. Definitions">
                            <p>
                                1.1. “Agreement” means this agreement, and any schedules and price lists, as may be
                                amended
                                from
                                time to time.
                                <br><br>
                                1.2. “Client/s” means your clients and customers, being individuals who consult with you
                                for
                                goods,
                                services, advice and/or treatment.
                                <br><br>
                                1.3. “Confidential Information” means all information disclosed by you and/or your
                                Clients,
                                and
                                includes, without limitation: Client information, including names, identifying numbers,
                                contact
                                details,
                                business or personal conditions, insurance details, family members’ details; your
                                information,
                                including
                                your name, registration number, practice number, contact details; your business
                                information,
                                including
                                strategies, intentions, product information, design rights, trade secrets, patents,
                                trademarks,
                                employee
                                details, financial information; and all information that is confidential, relates to
                                your
                                business
                                affairs, and is not generally available to the public.
                                <br><br>
                                1.4. “Effective Date” means the date that you appoint Kitrin to perform the Services.
                                <br><br>
                                1.5. “Fees” means the monthly (or annual, as applicable) fees payable by you to Kitrin
                                in
                                remuneration
                                for the Services, and any additional fees, charges, costs and expenses reasonably
                                incurred in
                                the
                                performance of the Services.
                                <br><br>
                                1.6. “Initial Period” means a period of 12 (twelve) months calculated from the Effective
                                Date.
                                <br><br>
                                1.7. “Kitrin” means Kitrin (UK) Limited, a private company incorporated in accordance with
                                the
                                laws
                                of
                                the United Kingdom.
                                <br><br>
                                1.8. “Services” means Administration Services, Financial Services and Marketing Services
                                performed
                                for
                                you by Kitrin, and includes any consulting and ancillary services rendered by Kitrin and
                                such
                                other
                                services as may be agreed in writing.
                                <br><br>
                                1.9. “You, your” means you, the Client, being a professional practitioner, advisor, sole
                                proprietor
                                and/or business entity for whom Kitrin will perform the Services.
                                <br><br>
                                1.10. “Website” means the internet site owned by Kitrin being www.theforge.online, or
                                such
                                alternate
                                internet site that Kitrin may notify to you in writing.
                                <br><br>
                                1.11. Reference to the singular includes the plural, reference to natural persons
                                includes
                                legal
                                persons, and reference to gender includes the other gender and the neuter.

                            </p>
                        </AccordionTab>
                        <AccordionTab header="2. Appointment and Duration">
                            <p>
                                2.1. You appoint and grant Kitrin the mandate, and Kitrin accepts this appointment and
                                mandate,
                                to
                                perform the Services.
                                <br><br>
                                2.2. This Agreement does not create a relationship of employment, agency or partnership
                                between
                                you
                                and
                                Kitrin. You will remain solely liable for the proper conducting of your affairs,
                                including the
                                marketing, administration, operational and financial components of your business
                                affairs. Such
                                affairs
                                and marketing, administration, operational and financial components are not in any way
                                being
                                delegated
                                to Kitrin, and Kitrin’s appointment will be limited to one of service provider to you
                                and your
                                business.
                                <br><br>
                                2.3. This agreement will commence on the Effective Date and endure for the Initial
                                Period.
                                Kitrin
                                will
                                notify you 2 (two) calendar months before the termination of the Initial Period,
                                whereupon you
                                will
                                have
                                the option of:
                                <br><br>
                                2.3.1. cancelling this Agreement at the end of the Initial Period. Your election to
                                cancel
                                must
                                be
                                notified to Kitrin in writing no less than 30 (thirty) days before termination of the
                                Initial
                                Period; or
                                <br><br>
                                2.3.2. renewing this Agreement for a further 12 (twelve) month period.
                                <br><br>
                                2.4. If you fail to make an election in terms of 2.3 above, this Agreement will continue
                                operating
                                and
                                will be subject to termination by either party on 1 (one) calendar month’s written
                                notice. In
                                such
                                instance, the monthly Fees will be increased to the monthly fees chargeable in
                                accordance with
                                Kitrin’s
                                standard schedule of fees at the time plus 10% (ten percent).
                                <br><br>
                                2.5. Notwithstanding 2.3 above, you will be entitled terminate this Agreement without
                                penalty
                                on
                                20
                                (twenty) business days written notice within the first 2 (two) months after the
                                Effective
                                Date.
                                This
                                clause 2.5 will not apply to any renewal of this Agreement.
                                <br><br>
                                2.6. Should you terminate this Agreement prematurely, other than in terms of 2.5, you
                                will be
                                liable
                                to
                                pay a cancellation fee equating to a minimum of 2 (two) months’ Fees.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="3. Fees payable">
                            <p>
                                3.1. You will pay to Kitrin monthly fees in accordance with Kitrin’s standard schedule
                                of
                                fees,
                                as
                                reflecting on the Website.
                                <br><br>
                                3.2. Fees are payable by debit order, monthly in advance. No refunds will be given in
                                the
                                event
                                that
                                you
                                terminate this Agreement early, and any payment made towards an unused period of the
                                month
                                will
                                be
                                retained by Kitrin.
                                <br><br>
                                3.3. Alternatively, Fees may be payable annually in advance. Should you elect an annual
                                payment
                                option,
                                you understand that the annual Fees comprise a discounted fee, and accordingly no
                                refunds will
                                be
                                given
                                in the event that you terminate this Agreement early for any reason. Any payment made
                                towards
                                an
                                unused
                                period of the year will be retained by Kitrin as a cancellation penalty.
                                <br><br>
                                3.4. Should Kitrin terminate this Agreement early, and provided that you have not
                                breached any
                                term
                                of
                                this Agreement, Kitrin will reimburse you the pro-rata Fees that you have paid in
                                respect of
                                the
                                unused
                                period of the applicable contract period.
                                <br><br>
                                3.5. You will reimburse Kitrin for any out-of-pocket expenses reasonably incurred by
                                Kitrin in
                                its
                                performance of the Services, including, without limitation, travel and accommodation
                                expenses,
                                and
                                any
                                fees paid to consultants, auditors, attorneys, contractors, debt-collectors or
                                specialists.
                                Kitrin
                                will
                                notify you of the need for these expenses before incurring them. Any such additional
                                fees,
                                charges
                                and
                                expenses will be payable by you within 7 (seven) days after invoice.
                                <br><br>
                                3.6. Kitrin reserves the right to review the Fees in the event that additional Services
                                are
                                required, or
                                due to a change in any material factor affecting the Services. Fees are calculated
                                according
                                to
                                the
                                size
                                of your business. Accordingly, Fees may be increased should the size of your business
                                increase.
                                Fees
                                will increase annually, effective 01 January each year, in an amount determined by
                                Kitrin, but
                                not
                                exceeding 10% (ten percent). Kitrin will give you no less than 30 (thirty) days written
                                notice
                                of
                                any
                                intended increase in Fees.
                                <br><br>
                                3.7. Outstanding amounts will attract a penalty of 2% per month, compounded monthly.
                                <br><br>
                                3.8. Kitrin will be entitled to suspend its performance of the Services should any
                                amount due
                                by
                                you
                                be
                                outstanding, until such time as full payment has been made. Such suspension will not
                                constitute
                                a
                                breach
                                of this Agreement.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="4. Operations and Administration Services">
                            <p>
                                4.1. “Administration Services” means administrative and operational services performed
                                by
                                Kitrin
                                on
                                your
                                behalf, including Client appointment scheduling, invoicing, payment allocations,
                                following up
                                on
                                insurance claims, debtor management, and such other administration services as may be
                                offered
                                to
                                you
                                by
                                Kitrin from time to time.
                                <br><br>
                                4.2. As many of the Administration Services are conducted electronically, it is your
                                responsibility
                                to
                                ensure that you have uninterrupted internet connectivity and access to the Website. In
                                the
                                event
                                that
                                you identify, experience or encounter any technical difficulties with the operation of
                                the
                                Website,
                                you
                                will notify Kitrin without delay. Kitrin will endeavour to correct the technical problem
                                as
                                soon
                                as
                                reasonably practicable, this being the sole extent of Kitrin’s liability associated with
                                such
                                technical
                                difficulty.
                                <br><br>
                                4.3. Client bookings will be facilitated via the booking system on the Website. Client
                                understands
                                that
                                Kitrin will not be held liable for any incorrect, incomplete or ambiguous information
                                provided
                                by
                                Clients, nor will Kitrin be liable if Clients arrive late for an appointment, fail to
                                arrive,
                                or
                                cancel
                                just before their appointment, for whatever reason.
                                <br><br>
                                4.4. You acknowledge that invoicing and payment allocation is dependent on you providing
                                the
                                correct
                                descriptions, codes, charges and amounts paid. Kitrin will follow up with Clients to
                                request
                                payment
                                of
                                outstanding charges and, where necessary, assist you in referring defaulters to
                                registered
                                debt-collectors for legal action.
                                <br><br>
                                4.5. When liaising with insurance companies, Kitrin will need to possess the correct
                                insurance
                                policy
                                details. Accordingly you will be responsible for viewing each Client’s original
                                insurance
                                card,
                                making a
                                copy of the details, and verifying the details against the Client information on the
                                Website.
                                <br><br>
                                4.6. The primary communication channel used to communicate with Clients will be their
                                email
                                addresses
                                and/or mobile numbers. It remains your responsibility to ensure that Kitrin is provided
                                with
                                correct
                                and
                                up-to-date Client contact details.
                                <br><br>
                                4.7. You understand and acknowledge that Kitrin gives no guarantee that the Services
                                will
                                result
                                in
                                profits, increased profits or reduced bad debts, and further that Kitrin cannot be held
                                liable
                                for
                                any
                                losses, increased losses or other damages suffered by you

                            </p>
                        </AccordionTab>
                        <AccordionTab header="5. Financial Services">
                            <p>
                                5.1. “Financial Services” means bookkeeping and monthly management accounts as may be
                                offered
                                to
                                you
                                by
                                Kitrin from time to time. Financial Services do not include payment services or payroll
                                management
                                unless expressly agreed in writing.
                                <br><br>
                                5.2. Kitrin may charge a once-off initiation fee for set-up and general take-on of your
                                accounts
                                if
                                your
                                bookkeeping is not up-to-date as at the Effective Date.
                                <br><br>
                                5.3. Kitrin will not be responsible for any registrations required for you to lawfully
                                operate
                                your
                                business. You will complete any registrations with all necessary authorities as required
                                to
                                carry
                                out
                                your business lawfully, including registration with relevant professional bodies, CIPC
                                and/or
                                SARS
                                registrations, and including registrations for the payment of all taxes, levies and
                                duties,
                                and
                                obtaining any licences and/or permits required to conduct your business.
                                <br><br>
                                5.4. You will remain liable to pay any penalties, fines or interest levied against you
                                by any
                                competent
                                authority, for whatever reason. Kitrin will assist you should you have grounds on which
                                to
                                challenge
                                any
                                such charges, but under no circumstances will Kitrin be liable for any penalties,
                                interest or
                                fines
                                that
                                may be levied against you from time to time, for whatever reason.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="6. Marketing Services">
                            <p>
                                6.1. “Designs” means the design, creation and generation of a website, artwork, graphic
                                design,
                                Marks,
                                processing images and logos, videography, photography, profiles, advertisements and
                                other
                                creative
                                design services.
                                <br><br>
                                6.2. “Marketing Services” means website management, content generation, electronic
                                listings,
                                and
                                such
                                other marketing services as may be offered to you by Kitrin from time to time, but
                                excludes
                                the
                                provision of Designs.
                                <br><br>
                                6.3. “Marks” means the various trademarks, service marks, trade names, logos and other
                                words
                                or
                                symbols
                                identifying you and/or your practice, goods or services.
                                <br><br>
                                6.4. You will be responsible for providing Kitrin with your Marks and Designs. You
                                warrant
                                that
                                you
                                are
                                entitled to such Marks and Designs, including all related copyright and trademarks, and
                                that
                                your
                                Marks
                                and Designs do not breach any law or third party rights. Kitrin is entitled to reject
                                any
                                Marks
                                or
                                Designs that you provide by virtue of the Mark or Design being: unlawful; unethical;
                                damaging
                                to
                                Kitrin’s reputation; furnished in the incorrect format; a breach of any third party’s
                                rights
                                or
                                copyright; discriminatory; inciteful; offensive; or otherwise potentially damaging, as
                                determined in
                                Kitrin’s sole discretion.
                                <br><br>
                                6.5. If Kitrin agrees to create and provide Designs for you, at Kitrin’s sole
                                discretion, this
                                will
                                result in additional Fees being charged at Kitrin’s standard rates.
                                <br><br>
                                6.6. You will remain responsible for paying your own domain charges, domain renewal
                                charges
                                and
                                hosting
                                charges.
                                <br><br>
                                6.7. Before publishing any Design, data, content or listing, Kitrin will submit a proof
                                to you
                                for
                                approval. You agree to approve or reject the proof within 5 (five) business days. If you
                                reject
                                the
                                proof you will provide reasons for your rejection. Your delay or failure to approve or
                                reject
                                will
                                not
                                have any impact on payment dates, and you will remain liable for the payment of all
                                Fees.
                                <br><br>
                                6.8. You will be responsible for ensuring that Kitrin is in possession of your most
                                up-to-date
                                details,
                                including name, business address, email address and contact details.
                                <br><br>
                                6.9. Kitrin will not, under any circumstances, be liable for any errors, omissions or
                                ambiguities in
                                any
                                content or listing, and nor will Kitrin bear any responsibility for ensuring that
                                content and
                                listings
                                remain up-to-date. You will be responsible for ensuring that all content and listings
                                are and
                                remain
                                correct in all material aspects and will further regularly review the content and
                                listings to
                                confirm
                                the continued correctness thereof.
                                <br><br>
                                6.10. While Kitrin will endeavour to publish content and listings without delay, you
                                understand
                                that
                                unavoidable delays and unintentional or third party errors may affect colour, content,
                                positioning
                                or
                                publication dates, for which Kitrin will not be held liable.
                                <br><br>
                                6.11. As applicable, Services will be primarily based on mainstream technology and
                                devices.
                                Kitrin
                                will
                                not be liable for any technical difficulties experienced due to users using new or
                                alternate
                                technology
                                and/or devices. As new hardware and software platforms are adopted worldwide and become
                                considered
                                as
                                mainstream, Kitrin may adapt its technological capabilities to allow the Services and
                                any
                                associated
                                applications to work with such new technology, where Kitrin adjudges it to be
                                commercially
                                feasible.
                                <br><br>
                                6.12. Support and maintenance for your website is limited to a maximum of 2 (two) hours
                                of
                                maintenance
                                per month, or such increased hours that may be included in the Services package chosen
                                by you.
                                Unused
                                time in a given month will be lost and may not be carried over to the next month.
                                <br><br>
                                6.13. You will remain responsible for: the accuracy, legibility, currency, and
                                compliance of
                                your
                                website and content; for any actual or alleged false, misleading, inaccurate, infringing
                                or
                                dated
                                material; and for compliance with any legal requirements.
                                <br><br>
                                6.14. Production, publication and completion of Marketing Services may vary due to,
                                without
                                limitation,
                                changes to website pages, and delays in your provision of input and approvals. Timelines
                                for
                                the
                                completion of Marketing Services will be a guideline only, and expected completion dates
                                may
                                change
                                due
                                to unexpected delays.
                                <br><br>
                                6.15. Third party service providers may update their services, processes and products
                                from
                                time
                                to
                                time,
                                affecting the Marketing Services. You acknowledge that these changes are beyond Kitrin’s
                                control. On
                                fulfilment of the Services, Kitrin will not be responsible for upgrading or modifying
                                any
                                content or
                                listings to comply with any updates.
                                <br><br>
                                6.16. Kitrin will endeavour to guard against downtime, security breaches, viruses and
                                system
                                failures,
                                but does not warrant same. Kitrin will not be liable to you for any network
                                interruptions,
                                security
                                breaches, downtime or interruption of internet service providers, and you will remain
                                liable
                                to
                                pay
                                all
                                Fees on their due dates.
                                <br><br>
                                6.17. Kitrin does not warrant or guarantee that information transmitted by or available
                                to you
                                by
                                way of
                                the Services will be preserved or be free of inaccuracies, defects, viruses or hacking.
                                Kitrin
                                assumes
                                no liability in regard to these exclusions.
                                <br><br>
                                6.18. You undertake responsibility for you own data storage, back up processes, virus
                                protection
                                mechanisms, security, and all other IT-related requirements not included in the
                                Services.
                            </p>
                        </AccordionTab>
                        <AccordionTab header="7. Confidential Information">
                            <p>
                                7.1. In order to facilitate Kitrin’s performance of the Services you will be required to
                                provide
                                identification, contact details, financial information, Client information and other
                                documents,
                                records
                                and data, including Confidential Information, as part of the registration process and
                                continued
                                use
                                of
                                the Services. All information that you are required to disclose must be promptly updated
                                after
                                any
                                change. Kitrin will not be responsible for any errors, omissions, fines or penalties as
                                a
                                result
                                of
                                your
                                failure to provide or update this information timeously, accurately and honestly.
                                <br><br>
                                7.2. To properly perform the Services, Kitrin may from time to time and within reason:
                                request
                                additional information and documentation; require you to provide approvals and input;
                                and/or
                                ask
                                you
                                to
                                conduct certain tasks or discharge certain obligations. If you fail to do so you will
                                remain
                                liable
                                to
                                Kitrin for payment of the Fees, regardless whether the Services have been fully
                                completed, and
                                Kitrin
                                will not be liable for any delays or non-compliance caused by your omission or delay.
                                <br><br>
                                7.3. Kitrin will keep all Confidential Information strictly confidential, and will not
                                use the
                                Confidential Information for its own benefit or transfer or disclose such Confidential
                                Information
                                or
                                part of it to any person not authorised to receive it, except with your prior written
                                consent
                                or
                                otherwise as may be required or permitted by law.
                                <br><br>
                                7.4. Insofar as may be applicable, Kitrin will implement such measures, controls and
                                security
                                safeguards
                                as may be reasonably necessary for it to discharge its legal obligations in respect of
                                any
                                data
                                protection and privacy laws that may apply to its provision of the Services. You will
                                remain
                                liable
                                to
                                comply with and discharge all and any statutory, regulatory and supervisory requirements
                                relating to
                                your affairs, business and Client confidentiality, and specifically any data protection
                                and
                                privacy
                                law
                                requirements related to your commercial affairs, business and confidentiality
                                obligations. You
                                will
                                remain responsible and accountable in respect of the collection, provision, publication,
                                use
                                and
                                recordal of Confidential Information, including the accuracy and quality of such
                                information,
                                and
                                the
                                legitimacy of the purpose for which the information has been collected, recorded and
                                used.
                                Where
                                required by law, you will notify affected customers, Clients and service providers of
                                your use
                                of
                                the
                                Kitrin’s Services and obtain any consents as may be legally required.

                            </p>
                        </AccordionTab>
                        <AccordionTab header="8. Limitation of Liability">
                            <p>
                                8.1. Kitrin will perform and render Services conscientiously and in accordance your
                                reasonable
                                requirements, and will endeavour to provide suggestions and general services based on
                                latest
                                developments.
                                <br><br>
                                8.2. Kitrin will take reasonable steps to secure its IT infrastructure with anti-virus
                                software
                                and
                                suitable encryption tools and will make every effort to protect the Confidential
                                Information.
                                While
                                Kitrin will use commercially reasonable efforts to comply with this clause, Kitrin does
                                not
                                warrant
                                that
                                the Services will be completely free from virus, hacking, theft or error.
                                <br><br>
                                8.3. Kitrin will not be liable for any consequential or special damages regardless of
                                cause,
                                including
                                without limitation, Client or third party claims, fines or penalties imposed on you,
                                damages
                                caused
                                by
                                loss of data, loss of profits, lost opportunity costs or loss of anticipated savings, or
                                resulting
                                in
                                expenses or wasted staff time. You indemnify Kitrin against all such claims and damages.
                                <br><br>
                                8.4. You agree to and hereby hold harmless and indemnify Kitrin, and its holding, sister
                                and
                                subsidiary
                                companies, as well as its affiliates, officers, directors, agents, employees,
                                advertisers and
                                partners,
                                from and against any claim by a Client and/or third party arising from or in any way
                                related
                                to
                                your
                                use
                                of the Services, your violation of this Agreement, or any other actions connected with
                                your
                                use
                                of
                                the
                                Services, including any liability or expense arising from all claims, losses, damages
                                (actual
                                and
                                consequential), actions, judgments, litigation costs and attorneys’ fees, of every kind
                                and
                                nature.
                                As
                                applicable, Kitrin will provide you with written notice of any such claim, suit or
                                action
                                brought or
                                threatened against it.
                                <br><br>
                                8.5. Without detracting from the contents of this clause 8, in the event that Kitrin is
                                found
                                to
                                be
                                liable to you for any reason by any competent authority having jurisdiction, Kitrin’s
                                cumulative
                                liability to you or any other party for any loss or damages resulting from any claims,
                                demands
                                or
                                actions arising out of or relating to this Agreement will not exceed the aggregate Fees
                                paid
                                by
                                you
                                to
                                Kitrin over the 6 (six) month period preceding the date the cause of action arose.
                                <br><br>
                                8.6. In the event that an applicable law does not allow limitations on implied
                                warranties or
                                the
                                exclusion or limitation of certain damages, any disclaimer, exclusion or limitation
                                herein
                                that
                                is
                                affected by such law will be modified to comply strictly with the applicable legislation
                                and
                                all
                                remaining provisions in this clause 8 will continue in force.
                                <br><br>
                                8.7. Although Kitrin uses all reasonable commercial efforts to maintain the
                                confidentiality of
                                Confidential Information, you agree that you will not hold Kitrin liable for any
                                damages,
                                regardless
                                of
                                its cause, and including, without limitation, due to technical glitches, unauthorised
                                intrusion
                                into
                                the
                                Kitrin’s data processing system, or bona fide error.

                            </p>
                        </AccordionTab>
                        <AccordionTab header="9. Termination and Breach">
                            <p>
                                9.1. This Agreement may be terminated by Kitrin with immediate effect if you fail to pay
                                any
                                Fees
                                that
                                are due, and despite having received written notice demanding payment.
                                <br><br>
                                9.2. This Agreement may be terminated by either party if:
                                <br><br>
                                9.2.1. the other commits a material breach of the Agreement;
                                <br><br>
                                9.2.2. the other commits an act of insolvency;
                                <br><br>
                                9.2.3. the other is placed into liquidation or under judicial management, business
                                rescue or
                                debt
                                administration, whether provisionally or finally;
                                <br><br>
                                9.2.4. a judicial manager, curator or trustee is appointed to the other Party, whether
                                provisionally
                                or
                                finally; or
                                <br><br>
                                9.2.5. the other is deregistered, dissolved, or ceases to carry on business.
                                <br><br>
                                9.3. Any clause that impliedly survives termination will survive termination of this
                                agreement.
                                <br><br>
                                9.4. Forthwith upon termination of this Agreement Kitrin will terminate the Services.
                                Copies
                                of
                                your
                                data and any Confidential Information stored by Kitrin and/or in Kitrin’s possession as
                                at the
                                termination date will be made available for your collection and/or electronic download
                                for a
                                period
                                of
                                10 (ten) days following the cancellation hereof, whereafter Kitrin will delete such data
                                and
                                Confidential Information, with the exception of any information that Kitrin is lawfully
                                obliged
                                to
                                retain, which information will be promptly destroyed after termination of the legal
                                retention
                                period. It
                                is your sole responsibility to ensure that you retrieve such data and Confidential
                                Information
                                from
                                Kitrin.
                                <br><br>
                                9.5. Should either party commit a breach of this agreement and fail to remedy such
                                breach
                                within
                                20
                                (twenty) days after receipt of written demand, the aggrieved party will be entitled to
                                either
                                claim
                                specific performance or to cancel this agreement, and to claim damages from the
                                defaulting
                                party,
                                including any attorney and client legal costs incurred. Provided that cancellation will
                                only
                                be
                                permissible in the event of a material breach.
                            </p>
                        </AccordionTab>

                        <AccordionTab header="10. General">
                            <p>
                                10.1. Any notice under this Agreement will be delivered to the physical business address
                                of
                                the
                                parties
                                as set out in writing, being the address at which each party agrees to receive all
                                notices, or
                                as
                                amended on written notification to the other party. In addition, Kitrin may send you
                                notices
                                via
                                email,
                                and/or display links to such notices on the Website. Kitrin is permitted to use such
                                methods
                                to
                                inform
                                you of any notifications under this Agreement, including renewals and any pricing
                                adjustments,
                                as
                                well
                                as provide you with letters of demand.
                                <br><br>
                                10.2. Any reference to Kitrin’s obligation to provide written notice will include the
                                provision
                                of
                                electronic notices, including the provision of publicly-available notices on the
                                Website,
                                emails
                                sent to
                                the latest email address provided by you, and private notices posted to your profile on
                                the
                                Website.
                                <br><br>
                                10.3. Neither party will, without the other’s consent, either during, or within 1 (one)
                                year
                                after
                                termination hereof, employ or solicit for employment any employee of the other party,
                                nor in
                                any
                                way
                                bring about or cause the resignation of any employee of the other party.
                                <br><br>
                                10.4. You will not assign, cede or delegate any of your rights or obligations hereunder
                                or any
                                part
                                thereof, or attempt to do so, without Kitrin’s prior written consent.
                                <br><br>
                                10.5. Kitrin may assign its rights and obligations on 2 (two) months prior written
                                notice to
                                you.
                                <br><br>
                                10.6. If any provision of the Agreement is invalid or unenforceable, such provision will
                                be
                                amended,
                                if
                                possible, to give effect thereto, and failing that, deleted. The remaining provisions
                                will
                                remain of
                                full force and effect.
                                <br><br>
                                10.7. No indulgence by either party will be construed as a waiver of or otherwise affect
                                any
                                rights
                                in
                                terms hereof, or prevent a party from enforcing compliance with this Agreement.
                                <br><br>
                                10.8. This Agreement constitutes the whole agreement between the parties. No amendment,
                                variation or
                                cancellation hereof will be binding unless in writing and signed by both parties. You
                                may also
                                be
                                subject to additional terms and conditions that may apply when you use or purchase
                                certain
                                other
                                Kitrin
                                services, affiliate services, third-party content or third-party software. Such
                                additional
                                terms
                                will
                                not supersede this Agreement. In the event of conflict the more restrictive provision
                                will
                                apply.
                                <br><br>
                                10.9. Every attempt has been made to ensure this agreement has been drafted in
                                accordance with
                                all
                                statutory requirements. Any non-compliance is not intended by the parties. If any
                                provision is
                                held
                                to
                                be unenforceable for any reason, including pursuant to a legal requirement or any change
                                in
                                the
                                law
                                that
                                impacts upon this agreement, such provision will be adjusted, if possible, to achieve
                                the
                                intent
                                of
                                the
                                parties, within legal parameters. If adjustment is not possible, the provision will be
                                deleted
                                and
                                all
                                other provisions will be considered valid and enforceable.
                                <br><br>
                                10.10. This Agreement will be governed by and interpreted in accordance with the laws of
                                South
                                Africa.
                                You and Kitrin hereby submit to the jurisdiction of the High Court of the United Kingdom. In
                                the
                                event
                                of
                                any
                                conflict with any other law, the law of the United Kingdom will apply.
                            </p>
                        </AccordionTab>

                    </Accordion>

                </div>
            </div>
        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        await this.loadCompanyContext();
    },
    data() {

        return {
            profile: {},
        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                console.log(
                    '[Appointments][watch] Company changed:',
                    oldCompanyId,
                    '→',
                    newCompanyId
                );

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                // Attempt to get user data
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                console.error("[AppointmentsNew][mounted] Error fetching user data = ", e);
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
